import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const InfoIcon = ({
  round,
  containerColor,
  containerSize,
  color,
  size,
  onClick,
  className,
}) => (
  <WithIconRounded
    round={round}
    containerColor={containerColor}
    containerSize={containerSize}
    className={className}
    onClick={onClick}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49992 13.6673C3.81792 13.6673 0.833252 10.6827 0.833252 7.00065C0.833252 3.31865 3.81792 0.333984 7.49992 0.333984C11.1819 0.333984 14.1666 3.31865 14.1666 7.00065C14.1666 10.6827 11.1819 13.6673 7.49992 13.6673ZM7.49992 12.334C8.91441 12.334 10.271 11.7721 11.2712 10.7719C12.2713 9.77169 12.8333 8.41514 12.8333 7.00065C12.8333 5.58616 12.2713 4.22961 11.2712 3.22942C10.271 2.22922 8.91441 1.66732 7.49992 1.66732C6.08543 1.66732 4.72888 2.22922 3.72868 3.22942C2.72849 4.22961 2.16659 5.58616 2.16659 7.00065C2.16659 8.41514 2.72849 9.77169 3.72868 10.7719C4.72888 11.7721 6.08543 12.334 7.49992 12.334V12.334ZM6.83325 3.66732H8.16659V5.00065H6.83325V3.66732ZM6.83325 6.33398H8.16659V10.334H6.83325V6.33398Z"
        fill={color}
      />
    </svg>
  </WithIconRounded>
);

InfoIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

InfoIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: '#18223D',
  containerColor: null,
  containerSize: 40,
  onClick: null,
  round: false,
  size: 16,
};

export default InfoIcon;
